import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavLink, Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Nav,
  NavItem,
  NavLink as RsNavLink,
  NavbarToggler
} from 'reactstrap';
import nav from './_nav';
import DropdownUser from './_dropdown';
import DropdownCompany from './_dropdownCompany/index';
import DropdownCourse from './_dropdownCourse/index';

import DropdownLang from './_dropdownLang';

// mobile! del
const mobileSidebarToggle = (ev) => {
  ev.preventDefault();
  document.body.classList.toggle('sidebar-mobile-show');
};
const isExternal = url => (url ? url.substring(0, 4) === 'http' : false);

const mapStateToProps = ({ user, i18n: { locale } }) => ({
  user,
  locale,
});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

const Header = ({ intl, user, locale }) => (
  <header>
    <div key={locale} className="content app-header navbar">
      {/* mobile! */}
      {user.options.hide_links_on_learning ? '' :
        <NavbarToggler className="navbar-mmenu" onClick={mobileSidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      }
      {/*  */}
      <Link className="header-logo" to="/"><img src={user.company_logo || '../img/logo.png'} alt="Logo" /></Link>
      {user.options.hide_links_on_learning ? '' :
        <div className="navigation-header">
          <div style={{ display: 'flex' }}>
            <Nav className="d-lg-down-none mob-down-none" navbar>
              <DropdownCompany user={user} />
              <DropdownCourse user={user} />
              <DropdownLang />
            </Nav>
          </div>
        </div>
      }
      <Nav navbar className="user-name">
        <DropdownUser />
      </Nav>
    </div>
  </header>
);

Header.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  locale: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Header));



// WEBPACK FOOTER //
// ./src/components/_Header/index.js